<div class="container">
  <div class="mbr-section mbr-section__container mbr-section__container--middle">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 text-xs-center" id="div1_style">
          <h1 class="mbr-section-title h2_font_size">Wishlist</h1>
          <div class="hr"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="favoruiteProducts.length > 0">
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6 col-6" style="margin-bottom: 10px;"
        *ngFor="let product of favoruiteProducts; let i = index">
        <div [class.out-of-stock]="product.outOfStock" class="product-grid-wrapper">
          <div class="card card-cascade wider product-grid-item">
            <div *ngIf="product.cartProductType == 'Product'" class='product_image'>
              <img src="../../../../assets/img/{{product.product_Picture}}" class='img-fluid pd_img_border'
                alt="Image not found" width="360px" height="300px"
                onerror="this.src='../../../../assets/img/defaultCake.webp';"
                [routerLink]="['/product', product.product_Code]" />

              <div class="img_left_top">
                <div *ngIf="product.offers >= 1" class="offer_img_div" (click)="viewOfferDetail(product.offerDetails)"
                  matTooltip="Offers">
                  OFFER
                </div>

                <img *ngIf="product.food_Type == 'Veg'" class="food_type_align" src="../../../../assets/img/Veg.webp"
                  alt="" />
                <img *ngIf="product.food_Type == 'Non-Veg'" class="food_type_align"
                  src="../../../../assets/img/Nonveg.webp" alt="" />
              </div>

              <div class="img_right_top">
                <a class="img_right_bg" placement="top" mdbTooltip="Remove Product" aria-label="Remove Product" container="body"
                  (click)="removeFavourite(product.product_Code)">
                  <i class="fa fa-trash" id="icon_align_pdl"></i>
                </a>

                <mat-icon class="img_right_bg" [matMenuTriggerFor]="menu" id="icon_align_pdl"
                  matTooltip="Share">share</mat-icon>
                <mat-menu #menu="matMenu">
                  <share-buttons theme="circles-dark" [include]="['copy','whatsapp','facebook','email','telegram']"
                    [showIcon]="true" [showText]="false" [url]="sharingUrl+product.product_Code"
                    [description]="product.product_Name" class="pt-5">
                  </share-buttons>
                </mat-menu>
              </div>
            </div>

            <div class='product_image' [routerLink]="['/make-product', product.product_Code]"
              *ngIf="product.cartProductType == 'Make To Order'">
              <div class='product_image'>
                <img src="../../../../assets/img/{{product.product_Picture}}" class='img-fluid pd_img_border'
                  alt="Image not found" width="360px" height="300px"
                  onerror="this.src='../../../../assets/img/defaultCake.webp';"
                  [routerLink]="['/product', product.product_Code]" />

                <div class="img_left_top">
                  <div *ngIf="product.offers >= 1" class="offer_img_div" (click)="viewOfferDetail(product.offerDetails)"
                    matTooltip="Offers">
                    OFFER
                  </div>

                  <img *ngIf="product.food_Type == 'Veg'" class="food_type_align" src="../../../../assets/img/Veg.webp"
                    alt="" />
                  <img *ngIf="product.food_Type == 'Non-Veg'" class="food_type_align"
                    src="../../../../assets/img/Nonveg.webp" alt="" />
                </div>

                <div class="img_right_top">
                  <a class="img_right_bg" placement="top" mdbTooltip="Remove Product" aria-label="Remove Product" container="body"
                    (click)="removeFavourite(product.product_Code)">
                    <i class="fa fa-trash" id="icon_align_pdl"></i>
                  </a>

                  <mat-icon class="img_right_bg" [matMenuTriggerFor]="menu" id="icon_align_pdl"
                    matTooltip="Share">share</mat-icon>
                  <mat-menu #menu="matMenu">
                    <share-buttons theme="circles-dark" [include]="['copy','whatsapp','facebook','email','telegram']"
                      [showIcon]="true" [showText]="false" [url]="sharingUrl+product.product_Code"
                      [description]="product.product_Name" class="pt-5">
                    </share-buttons>
                  </mat-menu>
                </div>
              </div>
            </div>

            <div class="p-4">
              <img *ngIf="product.outOfStock" src="../../../../assets/img/out-of-stock.png" class="out-of-stock-overlay"
                alt="Out of Stock">
              <h3 class="pdl_h3">
                <a *ngIf="product.cartProductType == 'Product'" [routerLink]="['/product', product.product_Code]"
                  routerLinkActive="router-link-active">
                  {{product.product_Name }}</a>
                <a *ngIf="product.cartProductType == 'Make To Order'"
                  [routerLink]="['/make-product', product.product_Code]" routerLinkActive="router-link-active">
                  {{product.product_Name }}</a>
              </h3>
              <div class="pd_d_flex">
                <span class="pdl_price">₹ {{ product.net_Sale_Price | number:
                  "1.2-2"
                  }}</span>
                <span class="portion_weight">
                  {{product.portion_Weight ? product.portion_Weight : ' '}}
                </span>
              </div>
              <div *ngIf="product.deliveryLabel" class="delivery-info">
                Earliest Delivery: <span>{{ product.deliveryLabel }}</span>
              </div>
              <div class="pdl_btn_div">
                <button type="button" class="pdl_btn" [disabled]="!product.stockAvailable"
                  (click)="addToCart(product, false)">Add to Cart</button>
                <button type="button" class="pdl_btn pdl_btn_buy" [disabled]="!product.stockAvailable"
                  (click)="addToCart(product, true)">Buy Now</button>
              </div>



              <!-- <div class="card-body text-center no-padding">
                <h5 class="card-title">
                  <strong>
                    <a [routerLink]="['/product', product.product_Code]" *ngIf="product.cartProductType == 'Product'">{{
                      product.product_Name }}</a>
                    <a [routerLink]="['/make-product', product.product_Code]"
                      *ngIf="product.cartProductType == 'Make To Order'">{{ product.product_Name }}</a>
                  </strong>
                </h5>

                <div class="card-footer">
                  <span>₹ {{ product.net_Sale_Price | number: "1.2-2" }}</span>
                  <span class="left">
                    <a placement="top" mdbTooltip="Remove Product" aria-label="Remove Product" container="body"
                      (click)="removeFavourite(product.product_Code)">
                      <i class="fa fa-trash" style="font-size: 17px; color: #e91e63"></i>
                    </a>
                  </span>
                  <span class="right" style="margin-right: -25px">
                    <a placement="top" mdbTooltip="Add to Cart" aria-label="Add to Cart" container="body" (click)="addToCart(product)">
                      <i class="fa fa-shopping-cart" style="margin-left: 6px;color: #e91e63;font-size: 19px;"></i>
                    </a>
                  </span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="favoruiteProducts.length === 0" class="col-md-12">
      <h4 class="empty"><i class="i-style">Your Wishlist is Empty</i></h4>
      <button type="button" class="btn btn-primary"
        style="display: block;padding-top: 10px;padding-bottom: 10px;font-size: 16px;font-weight: 500;border-radius: 4px;margin-top: 5px;float: right;"
        (click)="goShopping()">
        Start Shopping
        <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
      </button>
      <!-- <a class="btn btn-continue pull-right" routerLink="/">
      Start Shopping
      <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
    </a> -->
    </div>

    <!-- <div class="container">
    <div style="text-align: center; margin-top: -16px;">
      <button (click)="openScanner()" class="btn btn-primary">Open QR Scanner</button>
    </div>

    <div *ngIf="isScannerVisible" class="scanner-wrapper">
      <ngx-scanner-qrcode #action="scanner" (event)="onEvent($event, action)"></ngx-scanner-qrcode>
      <button (click)="closeScanner()" class="btn btn-danger close-btn">Close</button>
    </div>

  </div>

  <div style="text-align: center; margin-top: -6px;">
    <button (click)="jopenScanner()" class="btn btn-primary">Open QR ZXScanner</button>
  </div>

  <div *ngIf="jisScannerVisible" class="scanner-wrapper">
    <zxing-scanner [device]="selectedDevice" (scanSuccess)="onCodeResult($event)"></zxing-scanner>
    <button (click)="jcloseScanner()" class="btn btn-danger close-btn">Close</button>
  </div>

  <div *ngIf="scannedResult">
    <p>Scanned QR Code: {{ scannedResult }}</p>
  </div>

  <div *ngIf="isLoading" class="loading-indicator">
    <p>⌛ Loading Camera...</p>
  </div> -->






    <!-- <div class="container" *ngIf="favoruiteProducts.length === 0">
  <app-no-products-found [title]="messageTitle" [description]="messageDescription"></app-no-products-found>
</div> -->